export default {
  LIGHTBOX_DISABLE_ATTRIBUTE: 'lightbox-disabled',
  PLACEHOLDER_ATTRIBUTE: 'placeholder',
  BACKGROUND_PLACEHOLDER_ATTRIBUTE: 'background-placeholder',
  DATA_ALIGNMENT_ATTRIBUTE: 'data-alignment',
};
